import React, { useState } from 'react'

function Booking() {
  const [showSuccess, setShowSuccess] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    datetime: '',
    destination: '1',
    message: ''
  });

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    setFormData({
      ...formData,
      [e.target.id]: e.target.value
    });
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setShowSuccess(true);
    setTimeout(() => {
      setShowSuccess(false);
      setFormData({ name: '', email: '', datetime: '', destination: '1', message: '' });
    }, 5000);
  };

  return (
    <div>
      {/* Hero Header - Italian Theme */}
<div className="container-fluid py-5 mb-5 hero-header position-relative" style={{ 
  background: 'linear-gradient(135deg, rgba(11, 19, 32, 0.85) 0%, rgba(28, 62, 85, 0.85) 100%), url("https://images.unsplash.com/photo-1552832230-c0197dd311b5?ixlib=rb-4.0.3&auto=format&fit=crop&w=1396&q=80")',
  backgroundSize: 'cover',
  backgroundPosition: 'center 30%',
  backgroundRepeat: 'no-repeat'
}}>
  <div className="container py-5">
    <div className="row justify-content-center py-5">
      <div className="col-lg-10 pt-lg-5 mt-lg-5 text-center">
        <h1 className="display-3 text-white animated slideInDown">Booking</h1>
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb justify-content-center">
            <li className="breadcrumb-item">
              <a href="/" style={{ color: '#D4AF37' }}>Home</a>
            </li>
            <li className="breadcrumb-item text-white active" aria-current="page" style={{ color: '#FFFFFF' }}>
              Booking
            </li>
          </ol>
        </nav>
      </div>
    </div>
  </div>
</div>

      {/* Process Start - 3 Easy Steps */}
      <div className="container-xxl py-5" style={{ backgroundColor: '#FFFFFF' }}>
        <div className="container">
          <div className="text-center pb-4 wow fadeInUp" data-wow-delay="0.1s">
            <h6 className="section-title bg-white text-center px-3" style={{ color: '#D4AF37', fontWeight: '700' }}>
              Processo
            </h6>
            <h1 className="mb-5" style={{ color: '#0B1320' }}>3 Easy Steps to La Dolce Vita</h1>
          </div>
          <div className="row gy-5 gx-4 justify-content-center">
            <div className="col-lg-4 col-sm-6 text-center pt-4 wow fadeInUp" data-wow-delay="0.1s">
              <div className="position-relative border pt-5 pb-4 px-4 rounded shadow-sm h-100" style={{ borderColor: '#D4AF37', backgroundColor: '#FFFFFF' }}>
                <div className="d-inline-flex align-items-center justify-content-center rounded-circle position-absolute top-0 start-50 translate-middle shadow" style={{ width: 100, height: 100, backgroundColor: '#D4AF37' }}>
                  <i className="fa fa-map-marked-alt fa-3x" style={{ color: '#0B1320' }}></i>
                </div>
                <h5 className="mt-4" style={{ color: '#0B1320' }}>Choose Your Italian Destination</h5>
                <hr className="w-25 mx-auto mb-1" style={{ backgroundColor: '#D4AF37', height: '2px' }} />
                <hr className="w-50 mx-auto mt-0" style={{ backgroundColor: '#D4AF37', height: '1px' }} />
                <p className="mb-0" style={{ color: '#555555' }}>
                  Select from Rome, Florence, Venice, or Tuscany. Each destination offers unique audio-guided experiences and expert-led tours.
                </p>
              </div>
            </div>
            <div className="col-lg-4 col-sm-6 text-center pt-4 wow fadeInUp" data-wow-delay="0.3s">
              <div className="position-relative border pt-5 pb-4 px-4 rounded shadow-sm h-100" style={{ borderColor: '#D4AF37', backgroundColor: '#FFFFFF' }}>
                <div className="d-inline-flex align-items-center justify-content-center rounded-circle position-absolute top-0 start-50 translate-middle shadow" style={{ width: 100, height: 100, backgroundColor: '#D4AF37' }}>
                  <i className="fa fa-credit-card fa-3x" style={{ color: '#0B1320' }}></i>
                </div>
                <h5 className="mt-4" style={{ color: '#0B1320' }}>Book & Pay Securely</h5>
                <hr className="w-25 mx-auto mb-1" style={{ backgroundColor: '#D4AF37', height: '2px' }} />
                <hr className="w-50 mx-auto mt-0" style={{ backgroundColor: '#D4AF37', height: '1px' }} />
                <p className="mb-0" style={{ color: '#555555' }}>
                  Secure your spot with our easy online booking. Instant confirmation and free cancellation up to 24 hours before your tour.
                </p>
              </div>
            </div>
            <div className="col-lg-4 col-sm-6 text-center pt-4 wow fadeInUp" data-wow-delay="0.5s">
              <div className="position-relative border pt-5 pb-4 px-4 rounded shadow-sm h-100" style={{ borderColor: '#D4AF37', backgroundColor: '#FFFFFF' }}>
                <div className="d-inline-flex align-items-center justify-content-center rounded-circle position-absolute top-0 start-50 translate-middle shadow" style={{ width: 100, height: 100, backgroundColor: '#D4AF37' }}>
                  <i className="fa fa-headphones fa-3x" style={{ color: '#0B1320' }}></i>
                </div>
                <h5 className="mt-4" style={{ color: '#0B1320' }}>Explore with Audio Guide</h5>
                <hr className="w-25 mx-auto mb-1" style={{ backgroundColor: '#D4AF37', height: '2px' }} />
                <hr className="w-50 mx-auto mt-0" style={{ backgroundColor: '#D4AF37', height: '1px' }} />
                <p className="mb-0" style={{ color: '#555555' }}>
                  Download our app or pick up your device and start exploring Italy's treasures at your own pace.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Process End */}

      {/* Booking Start */}
      <div className="container-xxl py-5 wow fadeInUp" data-wow-delay="0.1s" style={{ backgroundColor: '#F8F9FA' }}>
        <div className="container">
          <div className="p-5 rounded shadow" style={{ backgroundColor: '#0B1320' }}>
            <div className="row g-5 align-items-center">
              <div className="col-md-6 text-white">
                <h6 className="text-white-50 text-uppercase" style={{ color: '#D4AF37 !important', letterSpacing: '1px' }}>
                  Prenotazione
                </h6>
                <h1 className="text-white mb-4" style={{ color: '#FFFFFF' }}>Online Booking</h1>
                <p className="mb-4" style={{ color: '#E0E0E0' }}>
                  Ready to explore Italy? Secure your spot on our guided tours or purchase our audio guides to explore at your own pace. Our team is here to help you create the perfect Italian itinerary.
                </p>
                <p className="mb-4" style={{ color: '#E0E0E0' }}>
                  From the Colosseum to the Uffizi, from Tuscan hills to Roman piazzas — let Via Italia Tours be your trusted companion. We offer flexible booking and free cancellation up to 24 hours before your tour.
                </p>
                <a className="btn py-3 px-5 mt-2 rounded-pill" href="/contact" style={{ backgroundColor: '#D4AF37', color: '#0B1320', fontWeight: 'bold' }}>
                  Contact Us
                </a>
              </div>
              <div className="col-md-6">
                <h1 className="text-white mb-4" style={{ color: '#D4AF37' }}>Book A Tour</h1>
                
                {/* Success Message */}
                {showSuccess && (
                  <div 
                    className="alert alert-success rounded-pill mb-4 animate__animated animate__fadeIn"
                    style={{ 
                      backgroundColor: '#D4AF37', 
                      color: '#0B1320',
                      border: 'none',
                      fontWeight: 'bold'
                    }}
                  >
                    <i className="fa fa-check-circle me-2"></i>
                    Your booking request has been forwarded! Our team will contact you within 24 hours to confirm. Grazie!
                  </div>
                )}
                
                <form onSubmit={handleSubmit}>
                  <div className="row g-3">
                    <div className="col-md-6">
                      <div className="form-floating">
                        <input
                          type="text"
                          className="form-control bg-transparent text-white"
                          id="name"
                          placeholder="Your Name"
                          style={{ borderColor: '#D4AF37' }}
                          value={formData.name}
                          onChange={handleChange}
                          required
                        />
                        <label htmlFor="name" style={{ color: '#D4AF37' }}>Your Name</label>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-floating">
                        <input
                          type="email"
                          className="form-control bg-transparent text-white"
                          id="email"
                          placeholder="Your Email"
                          style={{ borderColor: '#D4AF37' }}
                          value={formData.email}
                          onChange={handleChange}
                          required
                        />
                        <label htmlFor="email" style={{ color: '#D4AF37' }}>Your Email</label>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-floating date" id="date3" data-target-input="nearest">
                        <input
                          type="date"
                          className="form-control bg-transparent text-white"
                          id="datetime"
                          placeholder="Date"
                          style={{ borderColor: '#D4AF37' }}
                          value={formData.datetime}
                          onChange={handleChange}
                          required
                        />
                        <label htmlFor="datetime" style={{ color: '#D4AF37' }}>Select Date</label>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-floating">
                        <select
                          className="form-select bg-transparent text-white"
                          id="destination"
                          style={{ borderColor: '#D4AF37' }}
                          value={formData.destination}
                          onChange={handleChange}
                          required
                        >
                          <option value="1" style={{ backgroundColor: '#0B1320' }}>Rome: Colosseum & Forum Tour</option>
                          <option value="2" style={{ backgroundColor: '#0B1320' }}>Florence: Uffizi & Accademia Tour</option>
                          <option value="3" style={{ backgroundColor: '#0B1320' }}>Venice: St. Mark's & Gondola Ride</option>
                          <option value="4" style={{ backgroundColor: '#0B1320' }}>Tuscany: Wine Tour from Florence</option>
                          <option value="5" style={{ backgroundColor: '#0B1320' }}>Rome + Florence Combo (5 Days)</option>
                        </select>
                        <label htmlFor="destination" style={{ color: '#D4AF37' }}>Choose Your Tour</label>
                      </div>
                    </div>
                    <div className="col-12">
                      <div className="form-floating">
                        <textarea
                          className="form-control bg-transparent text-white"
                          placeholder="Special Request"
                          id="message"
                          style={{ height: 100, borderColor: '#D4AF37' }}
                          value={formData.message}
                          onChange={handleChange}
                        />
                        <label htmlFor="message" style={{ color: '#D4AF37' }}>Special Request (dietary needs, hotel preferences, etc.)</label>
                      </div>
                    </div>
                    <div className="col-12">
                      <button
                        className="btn w-100 py-3 rounded-pill"
                        type="submit"
                        style={{
                          backgroundColor: '#D4AF37',
                          color: '#0B1320',
                          fontWeight: 'bold',
                          transition: 'all 0.3s ease'
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.backgroundColor = '#87CEEB';
                          e.currentTarget.style.color = '#0B1320';
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.backgroundColor = '#D4AF37';
                          e.currentTarget.style.color = '#0B1320';
                        }}
                      >
                        Book Now
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Booking End */}
    </div>
  )
}

export default Booking